import { Ticket } from 'types/Event'
import { LocationType, SeatStatus } from 'types/Location'

export const formatDateYear = (date: Date): string => {
    const optionsDate: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }
    return new Intl.DateTimeFormat('hu-HU', optionsDate).format(date)
}

export const formatDateMonth = (date: Date): string => {
    const optionsDate: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric',
    }
    return new Intl.DateTimeFormat('hu-HU', optionsDate).format(date)
}

export const formatTime = (date: Date): string => {
    const optionsTime: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }
    return new Intl.DateTimeFormat('hu-HU', optionsTime).format(date)
}

export const formatDate = (dateString: string | undefined): string => {
    if (!dateString) return ''

    const date = new Date(dateString)

    // Use LOCAL time components for datetime-local input
    // If user sets 20:00 in form, it should be 20:00 in database
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')

    return `${year}-${month}-${day}T${hours}:${minutes}`
}

export const formatDateText = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }
    return new Intl.DateTimeFormat('hu-HU', options).format(new Date(dateString))
}

export const getPriceRange = (pricing: Array<{ price: number }>) => {
    return pricing.reduce(
        (acc, pricing) => {
            const price = pricing.price
            if (price < acc.min) acc.min = price
            if (price > acc.max) acc.max = price
            return acc
        },
        { min: Infinity, max: -Infinity },
    )
}

export const calculateIsSoldOut = (location: LocationType, tickets: Ticket[]): boolean => {
    const auditorium = location.auditorium

    const availableAuditoriumSeats =
        auditorium?.seats?.filter((seat) =>
            tickets.some((ticket) => ticket.seat_id === seat.seat_id && ticket.status === SeatStatus.Available),
        ).length || 0

    const availableGallerySeats =
        auditorium?.gallery?.seats?.filter((seat) =>
            tickets.some((ticket) => ticket.seat_id === seat.seat_id && ticket.status === SeatStatus.Available),
        ).length || 0

    return availableAuditoriumSeats + availableGallerySeats === 0
}

export const getSeasonText = (season: number | string): string => {
    const year = Number(season)

    if (isNaN(year)) {
        return `${season}`
    }

    const lastDigit = year % 10

    const suffixes: { [key: number]: string } = {
        1: '-es',
        2: '-es',
        3: '-as',
        4: '-es',
        5: '-ös',
        6: '-os',
        7: '-es',
        8: '-as',
        9: '-es',
        0: '-os',
    }

    const suffix = lastDigit === 0 ? suffixes[Math.floor((year % 100) / 10) % 10] || '-os' : suffixes[lastDigit] || '-os'

    return `${season}${suffix} évad`
}

export const getMonthYearText = (date: Date): string => {
    const monthsInHungarian = [
        'január',
        'február',
        'március',
        'április',
        'május',
        'június',
        'július',
        'augusztus',
        'szeptember',
        'október',
        'november',
        'december',
    ]

    const month = monthsInHungarian[date.getMonth()]
    const year = date.getFullYear()

    return `${year}. ${month}`
}
